
import { AuditLogEntity, EMPTY_AUDIT_LOG_ENTITY } from "domain/entity/AuditLog/AuditLogEntity";
import { AuditLogSearchCriteria, EMPTY_AUDIT_LOG_SEARCH_CRITERIA } from "domain/entity/AuditLog/AuditLogSearchCriteria";
import { DropdownProps } from "../DropdownProps";

export interface AuditLogDropdownOptions {
    opsLineDropdownOptions: DropdownProps[],
    forwarderCodeDropdownOptions: DropdownProps[],
    userDropdownOptions: DropdownProps[],
}

export interface AuditLogMaintenanceModel {
    isLoading: boolean,
    auditLogList: AuditLogEntity[],
    currentEntity: AuditLogEntity,
    isShowSearchPanel: boolean,
    isShowDetailPanel: boolean,
    searchCriteria: AuditLogSearchCriteria,
    dynamicOptions: AuditLogDropdownOptions,
    isSearchLoading?: boolean,
}

export const EMPTY_AUDIT_LOG_MODEL: AuditLogMaintenanceModel = {
    isLoading: false,
    auditLogList: [],
    isShowSearchPanel: false,
    searchCriteria: EMPTY_AUDIT_LOG_SEARCH_CRITERIA,
    dynamicOptions: {
        opsLineDropdownOptions: [],
        forwarderCodeDropdownOptions: [],
        userDropdownOptions: []
    },
    currentEntity: { ...EMPTY_AUDIT_LOG_ENTITY },
    isShowDetailPanel: false,
    isSearchLoading: true,
}